import { ArrowLeft, ArrowRight } from "lucide-react";
import { StatusBanner } from "@/components/StatusBanner";
import { ONBOARDING_STEPS, TOTAL_STEPS } from "@/features/onboarding/steps";

export function StepFrame({ step, children, onBack, onNext, nextLabel = "Save & continue", busy = false, busyLabel = "Saving", nextDisabled = false, status }) {
  const meta = ONBOARDING_STEPS[step];
  const problem = status && (status.state === "error" || status.state === "invalid");
  return (
    <form
      data-testid={`onboarding-step-${meta.key}`}
      onSubmit={(e) => {
        e.preventDefault();
        if (!busy && !nextDisabled) onNext();
      }}
      noValidate
      className="mw-rise"
    >
      <p className="mw-eyebrow hidden sm:block">{meta.n ? `Step ${meta.n} of ${TOTAL_STEPS}` : meta.label}</p>
      <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">{meta.title}</h1>
      <p className="mt-3 max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base">{meta.description}</p>
      <div className="mt-10">{children}</div>
      {problem && <div className="mt-8"><StatusBanner testId="onboarding-step-error">{status.message}</StatusBanner></div>}
      <div className="mt-10 flex flex-col-reverse gap-3 border-t border-border pt-6 sm:flex-row sm:items-center sm:justify-between">
        <button type="button" onClick={onBack} disabled={busy} data-testid="onboarding-back-button" className="mw-btn mw-btn-ghost">
          <ArrowLeft className="h-4 w-4" /> Back
        </button>
        <button type="submit" disabled={busy || nextDisabled} aria-busy={busy} data-testid="onboarding-next-button" className="mw-btn mw-btn-primary">
          {busy && <span className="mw-spinner mw-spinner-light" aria-hidden="true" />}
          {busy ? busyLabel : nextLabel}
          {!busy && <ArrowRight className="h-4 w-4" />}
        </button>
      </div>
    </form>
  );
}
